export const migrationModules = {
  dashboard: {
    status: 'active',
    priority: 'high',
    deliverables: [
      'Header summary strip',
      'KPI cards',
      'Date range control',
      'Charts and dashboard summaries'
    ]
  },
  attendance: {
    status: 'active',
    priority: 'high',
    deliverables: [
      'Attendance log table',
      'Punch flow with camera',
      'Leave and intimation actions',
      'Date range filtering'
    ]
  },
  tickets: {
    status: 'active',
    priority: 'high',
    deliverables: [
      'Ticket filters',
      'Ticket table and actions',
      'Create and edit flows',
      'Status ordering and approvals'
    ]
  },
  fms: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Task listing',
      'Task updates',
      'Done workflow',
      'Filters and status indicators'
    ]
  },
  approvals: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Approvals inbox',
      'Approval action buttons',
      'Approval status views'
    ]
  },
  myApprovalStatus: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Personal approval history',
      'Ticket, leave, intimation, attendance request status',
      'Type and search filtering',
      'Mongo-backed status tracking'
    ]
  },
  formsPortal: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Form listing table',
      'Manage access UI',
      'Selected-user visibility',
      'External form open behavior'
    ]
  },
  clientSocial: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Client ID scoped social task list',
      'Platform and status filters',
      'Approve / request changes actions',
      'History and remark view'
    ]
  },
  todo: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Single task create flow',
      'Bulk add flow',
      'Task status updates',
      'Personal to-do table'
    ]
  },
  clientsPortal: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Client dashboard',
      'Client tickets',
      'Invoices',
      'Client reports'
    ]
  },
  expenses: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Expense submit flow',
      'Expense listing',
      'Approval states'
    ]
  },
  reports: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'Report tabs',
      'Date range dropdown',
      'Export actions',
      'Ticket and FMS reporting tables'
    ]
  },
  managementDashboard: {
    status: 'active',
    priority: 'high',
    deliverables: [
      'Overview analytics',
      'User explorer',
      'Client explorer',
      'Batch assignment planner shell'
    ]
  },
  admin: {
    status: 'active',
    priority: 'medium',
    deliverables: [
      'EMP Master',
      'Users management',
      'Admin maintenance screens'
    ]
  }
};
